import React from "react"
import { NumericFormat } from "react-number-format"
import Image from "@/components/Shared/Image"
import Style from "@/components/MultiFinshProductBundle/styles/SelectedProductListUI.module.scss"
import arrowUp from "@/public/icons/arrow-up.svg"
import MissingImage from "@/public/images/image-missing.png"

const SelectedProductListUI = props => {
  const {
    productData = [],
    noOfChildItems = 0,
    currency = "",
    isOpen = false,
    handleIsOpen = () => {},
    staticTexts = {},
    finalProductPrice = 0,
    isPriceLoading = true,
  } = props || {}

  const {
    colorOrFinish = "",
    qty = 0,
    subTotal = "",
    includesItemsQty = () => {},
  } = staticTexts

  return (
    <div className={Style.BundleProductListSectionWrapper}>
      <div className="list">
        <div className="title">
          <div className="item" onClick={handleIsOpen} tabIndex={0}>
            <span>{includesItemsQty(noOfChildItems)}</span>
            <img
              className={`bundle-arrow ${isOpen ? "arrow-up" : "arrow-down"}`}
              src={arrowUp.src}
              alt={isOpen ? "Arrow Up" : "Arrow Down"}
            />
          </div>
          {!isOpen ? (
            <div className="subtotal">
              {`${subTotal}`} &nbsp;
              {!isPriceLoading && finalProductPrice ? (
                <NumericFormat
                  value={finalProductPrice}
                  displayType="text"
                  thousandSeparator={true}
                  prefix={currency}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              ) : (
                <p className="shimmer-loading__para shimmer width-170 price-spinner-subtotal" />
              )}
            </div>
          ) : null}
        </div>
        <div className={`lists items ${isOpen ? "list-open" : "list-close"}`}>
          {productData.map(item => {
            const {
              image = MissingImage,
              productName = "",
              color = "",
              quantity = 0,
              unitPrice = 0,
              sku = "",
            } = item || {}

            return (
              <React.Fragment key={sku}>
                <div className="child-items">
                  <div className="image">
                    <Image width={50} height={50} src={image} alt={sku} />
                  </div>
                  <div className="section">
                    <div className="title">{productName}</div>
                    <ul className="attributes">
                      <li>
                        {colorOrFinish}:<span className="details">{color}</span>
                      </li>
                      <li>
                        {qty}:<span className="details">{quantity}</span>
                        <p className="price-group mobile">
                          <span className="price">
                            <NumericFormat
                              value={unitPrice}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={currency}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </span>
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div className="price-group">
                    <p className="price">
                      <NumericFormat
                        value={unitPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={currency}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </div>
                </div>
              </React.Fragment>
            )
          })}
        </div>
        {isOpen ? (
          <div className="subtotal">
            {subTotal}&nbsp;
            {!isPriceLoading && finalProductPrice ? (
              <NumericFormat
                value={finalProductPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currency}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : (
              <p className="shimmer-loading__para shimmer width-170 price-spinner-subtotal" />
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}
export default SelectedProductListUI
